import { SliceComponentProps } from "@prismicio/react";
import React from "react";
import { getImage, withArtDirection } from "gatsby-plugin-image";

import { mediaQueries } from "@ui/themes/default";
import { Text } from "@ui/Atoms";

import { PrismicLandingPageV2DataBodyBenefitexplanation } from "@www/graphql-types";

import * as Styled from "./BenefitExplanation.styled";

export const BenefitExplanation = (
  props: SliceComponentProps<PrismicLandingPageV2DataBodyBenefitexplanation>,
) => {
  const primary = props.slice.primary;
  const isWide = !!primary.wide;
  const isInversed = !!primary.inversed;

  const benefitImage =
    primary.explanation_image?.gatsbyImageData &&
    withArtDirection(getImage(primary.explanation_image.gatsbyImageData)!, [
      {
        media: mediaQueries.desktop,
        image: getImage(
          primary.explanation_image?.thumbnails.desktop?.gatsbyImageData,
        )!,
      },
      {
        media: mediaQueries.tablet,
        image: getImage(
          primary.explanation_image?.thumbnails.tablet?.gatsbyImageData,
        )!,
      },
      {
        media: mediaQueries.desktopLarge,
        image: getImage(
          primary.explanation_image?.thumbnails.desktopLarge?.gatsbyImageData,
        )!,
      },
    ]);

  const wideBenefitImage =
    primary.explanation_image?.thumbnails.wide_main?.gatsbyImageData &&
    withArtDirection(
      getImage(primary.explanation_image.thumbnails.wide_main.gatsbyImageData)!,
      [
        {
          media: mediaQueries.desktop,
          image: getImage(
            primary.explanation_image?.thumbnails.wide_desktop?.gatsbyImageData,
          )!,
        },
        {
          media: mediaQueries.desktopLarge,
          image: getImage(
            primary.explanation_image?.thumbnails.wide_desktopLarge
              ?.gatsbyImageData,
          )!,
        },
      ],
    );

  return (
    <Styled.Root>
      <Styled.Benefit>
        <Styled.DescriptionWrapper inversed={isInversed} wide={isWide}>
          <Text as="h2" $color="grey800" $style="bold_32">
            {primary.explanation_title.text}
          </Text>
          <Text
            as="p"
            $color="grey400"
            $style={{ default: "regular_16", largeMobile: "regular_18" }}
          >
            {primary.explanation_description.text}
          </Text>
        </Styled.DescriptionWrapper>

        <Styled.ImageWrapper inversed={isInversed} wide={isWide}>
          {!isWide && (
            <Styled.ResponsiveImage
              image={benefitImage}
              alt={primary.explanation_image?.alt || ""}
            />
          )}

          {isWide && (
            <Styled.WideImage
              image={wideBenefitImage}
              alt={primary.explanation_image?.alt || ""}
            />
          )}
        </Styled.ImageWrapper>
      </Styled.Benefit>
    </Styled.Root>
  );
};
